import { RawUser, User } from "./user";
import { Token } from "../infrastructure/auth";

export abstract class UserRepository {
  getCurrentUser: () => User;
  updateUser: (updatedUser: RawUser) => Promise<void>;
  create: (newUser: RawUser, newPassword: string) => Promise<void>;
  updateMetadataNames: (
    metadata: string[],
    deletedMetadata: number[],
    updatedMetaDataNames: { id: number; name: string }[],
  ) => Promise<any>;
  resetPassword: (userId: number, newPassword: string) => Promise<void>;
  getTimezoneValueById: (id: number) => string;
  validateUsernameExists: (username: string) => Promise<boolean>;
  init: () => Promise<void>;
  changeTenant: (tenantId: number) => Promise<void>;
  refreshAccessToken: () => Promise<Token>;
  delete: (userId: number) => Promise<void>;
  getUsers(
    userId: number = null,
    tenantId: number = null,
  ): Promise<Array<RawUser>> {
    return null;
  }
}
